import { StringTMap } from '@bn/shared/entities/index';
import { PlanType } from '../enums';

export const SHIELD_LIMITS: { [key in PlanType]: StringTMap<number> } = {
  [PlanType.Basic]: {
    rateLimitRulesCount: 2,
    customWafRulesCount: 0,
    customListCount: 1,
    customEntryCount: 1000,
  },
  [PlanType.Advanced]: {
    rateLimitRulesCount: 10,
    customWafRulesCount: 10,
    customListCount: 5,
    customEntryCount: 5000,
  },
  [PlanType.Business]: {
    rateLimitRulesCount: 25,
    customWafRulesCount: 25,
    customListCount: 10,
    customEntryCount: 15000,
  },
  [PlanType.Enterprise]: {
    rateLimitRulesCount: 9999999999,
    customWafRulesCount: 9999999999,
    customListCount: 9999999999,
    customEntryCount: 9999999999,
  },
};
